(function() {
  'use strict';
  
  /**
   * Render the subcategory menu for the mobile
   * @name SubcategoryScrollSideCmpCtrl
   * @type ItxSubCategoryCarouselMobileCmpCtrl
   */
  var SubcategoryScrollSideCmp = {
      bindings: {
          category: '<',
          onSectionLoaded: '&'
      },
      controller: SubcategoryScrollSideCmpCtrl,
      templateUrl: 'subcategory-scroll-side.component.html'
  };

  angular.module('itxApp.catalog').component('subcategoryScrollSide', SubcategoryScrollSideCmp);

  SubcategoryScrollSideCmpCtrl.$inject = [
      'categoryTreeSvc', 
      'logger', 
      'CmsConfigSvc', 
      'attachmentManagerSvc',
      '$rootScope'
  ];

  function SubcategoryScrollSideCmpCtrl(
      categoryTreeSvc, 
      logger, 
      CmsConfigSvc, 
      attachmentManagerSvc,
      $rootScope
  ) {
      var _this = this;
      _this.subcategories = null;
      
      _this.$onInit = function() {
       _this.loadParentCategory();
       setTimeout(function() {
         _this.addActiveCurrentCategory(_this.category.id);
       }, 500);
      };

      _this.loadParentCategory = function(initialLoad) {
        _this.subcategories = [];
        categoryTreeSvc.getFamilyCategoryId(_this.category.id)
        .then(function (res) {  
          if(res.levelTreeCategory === 3) {
            _this.subcategories = res.parentCategory.subcategories;
          }
          _this.category = res.category;
           initAttachment();
        })
        .catch(function (err) {
          // logger('Error al cargar subcategorías');
        });  
      }

      $rootScope.$on('subcategoryCarousel:onLoad', function(evt, category) {
        _this.category = category;
        _this.loadParentCategory();
        _this.addActiveCurrentCategory(category.id);
      });

      function initAttachment() {
        
          CmsConfigSvc.getProperty('category_attachments').then(function(data) {

              attachmentManagerSvc.initializeServiceValues(data).then(function() {
                
                  _this.subcategories.forEach(element => {

                    attachmentManagerSvc.checkAttachmentConfig(element);

                  });

              }).catch(function() {

                logger.log('Error al incializar attachments');

              });
          }).catch(function(){

            logger.log('Error al obtener key CMS');

          });
      }
  
      _this.$onChanges = function(change) {
        _this.addActiveCurrentCategory(change.category.currentValue.id);
      };

      _this.addActiveCurrentCategory = function(category) {
          $('.md-scroll-item').removeClass('is-active');
          $('[data-id-scroll='+ category +']').addClass('is-active');
      };

      _this.selectSubcategory = function(category) {
        $rootScope.$emit('categoryCtrl:loadCategory', category);
      }
  }
})();